import { ActivityTypeActionTypes, SET_ACTIVITY_TYPES } from './types';
import { ActivityType } from '../../../Types';

export const setActivityTypes = (activityTypes: ActivityType[]): ActivityTypeActionTypes => ({
  type: SET_ACTIVITY_TYPES,
  activityTypes
});
